export const generateGoogleMapUrl = (location?: string): string => {
  if (!location) {
    return "";
  }
  return `https://maps.google.com/?q=${encodeURIComponent(location)}`;
};
